import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { css, cx } from "@emotion/css";
import { GripDotsVerticalIcon } from "@octopusdeploy/design-system-icons";
import { borderRadius, borderWidth, colorScales, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { CSSProperties, ReactNode } from "react";
import { Text } from "../Form/Text";
import { DeprecatedIconButton } from "../IconButton";
export default function SortableItem({ id, name, label, customContent, onItemDeleted, onItemUpdated }: {
    id: string;
    name: string;
    label?: string;
    customContent?: ReactNode;
    onItemDeleted?: () => void;
    onItemUpdated?: (newValue: string) => void;
}) {
    const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({ id });
    const style: CSSProperties = {
        transform: CSS.Translate.toString(transform),
        transition,
    };
    return isDragging ? (<li className={cx(styles.sortableItemDropArea, { [styles.sortableItemDropAreaEditMode]: !!onItemUpdated })} {...attributes} {...listeners} ref={setNodeRef} style={style}>
            <div className={styles.sortableItemDropBar}/>
        </li>) : (<li className={styles.sortableItem} {...attributes} {...listeners} ref={setNodeRef} style={style}>
            <GripDotsVerticalIcon size={24}/>

            {customContent ? (customContent) : onItemUpdated ? (<div className={styles.itemName} data-no-dnd>
                    <Text label={label} value={name} onChange={(newValue: string) => {
                onItemUpdated(newValue);
            }}/>
                </div>) : (<span className={styles.itemName}>{name}</span>)}

            {onItemDeleted && (<div data-no-dnd>
                    <DeprecatedIconButton accessibleName={"Cancel"} icon={"XmarkIcon"} onClick={() => {
                onItemDeleted();
            }}/>
                </div>)}
        </li>);
}
const styles = {
    sortableItem: css({
        padding: space[12],
        border: `${borderWidth[1]} solid ${themeTokens.color.border.primary}`,
        borderRadius: borderRadius.medium,
        display: "flex",
        alignItems: "center",
        gap: space[8],
        backgroundColor: themeTokens.color.background.primary.default,
        cursor: "pointer",
        touchAction: "manipulation",
        ".MuiTextField-root": {
            marginBottom: "0 !important",
        },
    }),
    sortableItemDropArea: css({
        padding: space[12],
        height: "50px",
        width: "100%",
        display: "flex",
        alignItems: "center",
    }),
    sortableItemDropAreaEditMode: css({
        height: "78px",
    }),
    sortableItemDropBar: css({
        border: `${borderWidth[1]} solid ${colorScales.blue[500]}`,
        borderRadius: borderRadius.medium,
        backgroundColor: colorScales.blue[500],
        height: space[4],
        width: "100%",
    }),
    itemName: css({
        font: text.body.regular.large,
        width: "100%",
    }),
};
